export class PdfReceiptGenerate {
    #generateReceiptButton = null;
    constructor() {
        this.#generateReceiptButton = document.querySelector('a.generate_pdf_receipt');
        if (this.#generateReceiptButton) {
            this.addEventsGeneratePdf();
        }
    }

    addEventsGeneratePdf() {
        this.#generateReceiptButton.addEventListener('click', async (event) => {
            event.preventDefault();
            if (typeof admin_ajax === 'undefined' || !Array.isArray(admin_ajax) || !admin_ajax[0]) {
                alert('System error: AJAX endpoint not found.');
                return;
            }
            const nonce = this.#generateReceiptButton.dataset.nonce;
            const orderId = this.#generateReceiptButton.dataset.id;
            if (!nonce || !orderId) {
                alert('Missing order information. Please refresh and try again.');
                return;
            }

            const originalText = this.#generateReceiptButton.textContent;
            const originalHref = this.#generateReceiptButton.getAttribute('href');
            this.#generateReceiptButton.disabled = true;
            this.#generateReceiptButton.textContent = 'Generating receipt…';

            try {
                const response = await fetch(admin_ajax[0], {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                    },
                    body: new URLSearchParams({
                        action: 'generate_pdf_receipt',
                        security: nonce,
                        order_id: orderId
                    })
                });

                const data = await response.json();
                if (data.success) {
                    const pdfUrl = data.data.pdf_url;
                    this.#generateReceiptButton.classList.remove('generate_pdf_receipt', 'generate_show_pdf_on_checkout');
                    this.#generateReceiptButton.href = pdfUrl;
                    this.#generateReceiptButton.textContent = 'View receipt';
                    this.#generateReceiptButton.disabled = false;

                    if (event.button === 1 || event.ctrlKey) {
                        window.open(pdfUrl, '_blank');
                    } else if (event.button === 0) {
                        window.location.href = pdfUrl;
                    }
                } else {
                    this.#generateReceiptButton.disabled = false;
                    this.#generateReceiptButton.textContent = originalText;
                    if (originalHref) this.#generateReceiptButton.setAttribute('href', originalHref);
                    console.log(data.data?.message || 'Failed to generate receipt.');
                }
            } catch (error) {
                this.#generateReceiptButton.disabled = false;
                this.#generateReceiptButton.textContent = originalText;
                if (originalHref) this.#generateReceiptButton.setAttribute('href', originalHref);
                console.error('AJAX error:', error);
            }
        });
    }
}
